module.exports = __webpack_public_path__ + "img/foundationStictching1.5bf5ad34.jpg";